import React from "react";
import PropTypes from "prop-types";

/**
 * OptionsDescription: Component renders the OptionsMessage displayed
 * displeyd on top of options listing
 */
export function OptionsDescription(props) {
  if (props.message)
    return (
      <div className="designOptions--body_description">{props.message}</div>
    );
  else return null;
}

OptionsDescription.propTypes = {
  /**
   * Message to be displayed for the particular message
   */
  message: PropTypes.string,
};

OptionsDescription.defaultProps = {
  message: "",
};
